import Drawable from '../entities/Drawable.js';
import { c } from '../setup.js';

export default class WhiteFlash extends Drawable {
    constructor() {
        super();
        this.visible = true;
        this.alpha = 0;
        this.isFlashing = false;
    }

    draw() {
        if (!this.visible) {
            return;
        }
        if (this.isFlashing) {
            if (this.alpha < 1) {
                this.alpha += 0.025;
            } else {
                this.isFlashing = false;
            }
        } else {
            if (this.alpha > 0) {
                this.alpha -= 0.025;
            } else {
                this.alpha = 0;
            }
        }
        c.fillStyle = `rgba(255, 255, 255, ${this.alpha})`;
        c.fillRect(0, 0, 240, 160);
    }

    flash() {
        this.isFlashing = true;
        this.alpha = 0.01;
    }
}
